/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2025. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2025. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez Cumbe
 * Date:         27/04/25 - 16:39:42
 * Module name:  bg-images.const
 * File name:    bg-images.const.ts
 * IDE:          WebStorm
 */

export const BACKGROUND_URL: string = 'https://picsum.photos/id/11/1920/2100';
export const LOGO_URL: string = '../assets/image/meerkad_light.webp';
